import _ from 'underscore'
import {load,getRef,saveIdObject,deleteIdObject} from './common'

export function loadTests() {
  return load('tests')
}

export function deleteTest(date) {
  getRef('tests').child(date).remove()
}

export function saveTest(date,test) {
  getRef('tests').child(date).child(test.rid+test.bid).set(test)
}



/** WEBPACK FOOTER **
 ** ./src/app/actions/tests.js
 **/